import axios from 'axios';
import { BACKEND_URL } from './backendUrl';

const API_URL = BACKEND_URL;

export const uploadImageToCdn = async (
  file: File,
  token?: string | null,
  folder: string = 'misc'
): Promise<string> => {
  if (!API_URL) {
    throw new Error('Backend URL is not configured');
  }

  if (!file.type.startsWith('image/')) {
    throw new Error('Please select an image file');
  }

  if (file.size > 5 * 1024 * 1024) {
    throw new Error('Image size should be less than 5MB');
  }

  const formData = new FormData();
  formData.append('file', file);

  const authToken = token || localStorage.getItem('token');
  const headers: Record<string, string> = {};
  if (authToken) {
    headers.Authorization = `Bearer ${authToken}`;
  }

  try {
    const response = await axios.post(
      `${API_URL}/api/uploads/image?folder=${encodeURIComponent(folder)}`,
      formData,
      { headers }
    );
    return response.data.url;
  } catch (error: any) {
    throw new Error(error?.response?.data?.error || error?.message || 'Image upload failed');
  }
};
